import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import NavContainer from "./NavContainer";
import SocialContainer from "./SocialContainer";
import AcademyContainer from "./AcademyContainer";

const Navbar = ({ sidebar, setSidebar, searchOverlay, setSearchOverlay }) => {
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="bg-white fixed top-0 w-screen nav-z">
      <SocialContainer />
      <NavContainer
        sidebar={sidebar}
        setSidebar={setSidebar}
        searchOverlay={searchOverlay}
        setSearchOverlay={setSearchOverlay}
      />
      {user && path.includes("/academy") && <AcademyContainer path={path} />}
    </div>
  );
};

export default Navbar;
